import React, {useState} from 'react';
import {FormInputComponent} from "../../../components/form/Form";
import {Badge, Empty, Modal, Tabs, InputNumber} from "antd";
import {usePositionForm} from "../../../providers/PositionFormProvider";
import {useAuth} from "../../../providers/AuthProvider";
import {useAPI} from '../../../config/API';
import LoadingBanner from '../../../components/LoadingBanner';
import {useOutletContext} from "react-router-dom";
import PositionDeliverablesForm from "./PositionDeliverablesForm";
import ReactPortal from "../../../components/ReactPortal";


const PositionFixedFeeForm = props => {
    const {auth} = useAuth();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const {onChange, isReadOnly: isContextReadOnly, isDisabled} = useOutletContext();

    const isReadOnly = isContextReadOnly || props.isReadOnly;

    const {
        formModel: position,
        isProjectUpdating,
        onFormReset
    } = usePositionForm();

    const [editingIndex, setEditingIndex] = useState(false)
    const [editingDeliverable, setEditingDeliverable] = useState(false)
    const [selectedTab, setSelectedTab] = useState('add-deliverables')

    const positionDeliverables = TB.orderBy( position.deliverables || [], del => del.target_delivery_at ? TB.moment(del.target_delivery_at).valueOf() : 0, 'asc')
    const {
        data: commonDeliverables = [],
        isLoading: isDeliverablesLoading,
    } = useAPI([
        'searchDeliverablesByDisciplines', {
        disciplines: TB.map(position.disciplines, 'id')
    }], {
        enabled: !isReadOnly
    })

    const toggleDeliverableForm = async (isOpen) => {
        setEditModalOpen(isOpen)
    }
    const editDeliverable = async (deliverable) => {
        await setEditingDeliverable(deliverable)
        await TB.wait(200)

        console.log('editDeliverable', deliverable)
        return toggleDeliverableForm(true)
    }

    const addNewDeliverable = async () => {
        return editDeliverable({name: '', description: '', is_adding:true})
    }

    const validDeliverables = TB.filter(positionDeliverables, del => del.name);

    const CurrentPositionDeliverables = (
        <div className="flex flex-col items-stretch gap-3 p-3 rounded-lg bg-gray-50">
            <p className="text-center underline">List of deliverables</p>
            <div className="relative flex items-stretch justify-center flex-col">

                {!validDeliverables.length ? (
                    <div className="py-5 self-center relative flex items-stretch justify-center flex-col">
                    <Empty description="Your selected or custom deliverables will appear here"
                               image={Empty.PRESENTED_IMAGE_SIMPLE}>

                            {!isReadOnly && (
                                <button
                                    type="button"
                                    className="btn btn-primary self-center whitespace-nowrap mx-auto"
                                    onClick={addNewDeliverable}
                                >
                                    Add Custom Deliverable
                                </button>
                            )}
                        </Empty>
                    </div>
                ) : (
                    <React.Fragment>
                        <div className="flex flex-col items-stretch divide-y gap-3 px-3">
                            {validDeliverables.map((deliverable, delIndex) => {
                                return (
                                    <div className="py-4 flex flex-row items-center gap-4" key={`del-${delIndex}`}>
                                        <p className="self-start">
                                            <i className={TB.mapClass("fas text-[26px]", {
                                                "fa-clipboard-check": true,//item.deliverable_id,
                                                // "fa-clipboard-list": !item.deliverable_id,
                                            })}/>
                                        </p>
                                        <div className="flex-grow flex flex-col gap-2">
                                            <p className="text-base whitespace-no-wrap font-semibold">
                                                {deliverable.name}
                                                {deliverable.deliverable_id ? (
                                                    <Badge className="ml-2" count="Selected"
                                                           style={{backgroundColor: TB.config('color.secondary')}}/>
                                                ) : ''}
                                            </p>

                                            <p className="text-sm line-clamp-5">
                                                {deliverable.description || (
                                                    <i>No Description Provided...</i>
                                                )}
                                            </p>
                                            <p className="text-sm line-clamp-5">
                                                {deliverable.target_delivery_at ? TB.moment(deliverable.target_delivery_at).format('ll') : (
                                                    <i>Target Date Not Provided</i>
                                                )}
                                            </p>
                                            <div className="relative flex flex-row items-start">
                                                <i className="text-sm far fa-sticky-note text-info mr-2"/>
                                                <p className="text-xs line-clamp-4 mt-0.5" title={deliverable.notes}>
                                                    {deliverable.notes ? (
                                                        <span>
                                                            <span className="font-semibold">
                                                                Notes:
                                                            </span>
                                                            &nbsp;
                                                            {deliverable.notes}
                                                        </span>
                                                    ) : (
                                                        <i>No Notes Provided...</i>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                        {!isReadOnly && (
                                            <div className="flex flex-col items-center justify-center gap-1">
                                                <button type="button"
                                                        className="btn btn-link btn-link-info whitespace-no-wrap px-0 py-0 min-w-[60px]"
                                                        onClick={() => {
                                                            return editDeliverable(deliverable)
                                                        }}>
                                                    Edit
                                                </button>
                                                <button type="button"
                                                        className="btn btn-link btn-link-danger px-0 py-0.5"
                                                        onClick={async () => {
                                                            let confirm = await TB.alert('error', 'Remove?',
                                                                'Are you sure you want to remove this deliverable?',
                                                                [
                                                                    {title: 'Yes, Continue'},
                                                                    {title: 'Cancel'}
                                                                ]
                                                            )

                                                            if (confirm) {
                                                                onChange({deliverables: positionDeliverables.filter(del => del.name !== deliverable.name)})
                                                            }
                                                        }}>
                                                    Remove
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                        {!isReadOnly && (
                            <button
                                type="button"
                                className="btn btn-primary self-center whitespace-nowrap mx-auto"
                                onClick={addNewDeliverable}
                                disabled={isProjectUpdating}
                            >
                                Add Custom Deliverable
                            </button>
                        )}
                    </React.Fragment>
                )}
            </div>

        </div>
    )

    const tabs = [
        {
            key: 'add-deliverables',
            label: (
                <span>
                    Select Deliverables&nbsp;{commonDeliverables?.length && `(${commonDeliverables.length})`}
                </span>
            ),
            children: (
                <div className="flex flex-col items-stretch gap-3 p-3 rounded-lg bg-gray-50">
                    <p className="mb-3">
                        <span>
                            Select from common deliverables across the roles you selected or
                        </span>
                        &nbsp;
                        <span onClick={e => {
                               if (isDisabled) {
                                   return e.preventDefault();
                               }
                               return addNewDeliverable()
                           }}
                           className="m-0 p-0 clickable btn-link-primary">
                            create your own deliverable
                        </span>
                    </p>

                    {isDeliverablesLoading && (
                        <div className="relative self-center py-5">
                            <LoadingBanner/>
                        </div>
                    )}

                    {commonDeliverables?.length > 0 ? commonDeliverables.map(item => {
                        const existsInSelected = TB.find(positionDeliverables, del => !del.is_adding && del.deliverable_id === item.id);

                        return (
                            <div key={item.id}>
                                <div className="flex items-center gap-4">
                                    <div>
                                        {!!existsInSelected ? (
                                            <div className="w-20">
                                                <p className="text-center">
                                                <i className="fa fa-check mr-1 text-success"/> Added!
                                                </p>

                                                <button
                                                    type="button"
                                                    onClick={async() => {
                                                        let confirm = await TB.alert('error', 'Remove?',
                                                            'Are you sure you want to remove this deliverable?',
                                                            [
                                                                {title: 'Yes, Continue'},
                                                                {title: 'Cancel'}
                                                            ]
                                                        );
                                                        if (confirm) {
                                                            onChange({
                                                                deliverables: TB.filter(positionDeliverables, del => !del.deliverable_id || del.deliverable_id !== item.id)
                                                            })
                                                        }
                                                    }}
                                                    className="btn btn-link p-0 m-auto"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={async () => {
                                                    await TB.wait(200);
                                                    await editDeliverable({...TB.pick(item, ['name', 'description']), deliverable_id: item.id, is_adding: true})
                                                }}
                                                className="btn btn-primary w-20"
                                            >
                                                Add
                                            </button>
                                        )}
                                    </div>

                                    <div className="flex-grow flex flex-col gap-2">
                                        <p className="text-base whitespace-no-wrap font-semibold">{item.name}</p>

                                        <p className="rich-text-display text-sm line-clamp-4">
                                            <span
                                                dangerouslySetInnerHTML={{__html: item.description || '<i>No Description Provided...</i>'}}/>
                                        </p>
                                    </div>

                                </div>
                                <div className="h-px bg-gray-400 w-4/5 my-4 mx-auto"/>
                            </div>
                        )
                    }) : (
                        <Empty description="No common deliverables found. You can create custom deliverables below"
                               image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                    )}


                    <button type="button"
                            className="btn btn-primary mt-1.5 mb-3 self-center whitespace-nowrap"
                            onClick={async () => {
                                return addNewDeliverable();
                            }}
                    >
                        Add Custom Deliverable
                    </button>
                </div>
            )
        },
        {
            key: 'selected-deliverables',
            label: (
                <Badge
                    count={validDeliverables?.length ? validDeliverables?.length : 0}>
                    <span className="mr-3">
                        Current Deliverables
                    </span>
                </Badge>
            ),
            children: CurrentPositionDeliverables
        },
    ]

    return (
        <div className="flex flex-col justify-start items-stretch self-stretch relative gap-3">

            <p className="self-stretch text-base font-medium text-left text-[#3f434a]">
                What's your budget for the deliverables that will be completed by <span className="italic">{position.title}</span>?
            </p>
            <div className="flex flex-row items-center justify-start">
                <div className="flex flex-col items-stretch basis-1/3">
                    <FormInputComponent
                        fieldName="budget"
                        value={position.budget}
                        isReadOnly={isReadOnly}
                        label={false}
                        type="antd-number"
                        required={true}
                        addonBefore="$"
                        placeholder="0.00"
                        min={0}
                        max={1000000}
                        validation={{
                            rules: {
                                isInt: true,
                                min(values, value) {
                                    if (!TB.isDefined(value)) return true;

                                    return parseInt(value) >= 0
                                },
                                max(values, value) {
                                    if (!TB.isDefined(value)) return true;
                                    return parseInt(value) <= 1000000;
                                },
                            },
                            errors: {
                                min: `The role budget must be greater than $0.00`,
                                max: `The role budget must be less than $1,000,000.00`,
                            }
                        }}
                        disabled={isProjectUpdating || isDisabled}
                    >
                        <InputNumber
                            controls={false}
                            className="[&>.ant-input-number-input-wrap]:w-24"
                            // className="w-full"
                            // addonAfter={<p>My total budget for this position</p>}
                            addonBefore="$"
                            required={false}
                        />
                    </FormInputComponent>
                </div>
            </div>

            <p className="self-stretch text-base font-medium text-left text-[#3f434a]">
                What specific deliverables do you want completed?
            </p>
            <div className="flex flex-col justify-start items-stretch self-stretch relative gap-4">
                {isReadOnly ? CurrentPositionDeliverables : (
                    <Tabs items={TB.filter(tabs, tab => !!tab)}
                          activeKey={selectedTab}
                          onChange={setSelectedTab}/>
                )}
            </div>

            {!isReadOnly && editingDeliverable && (
                <ReactPortal wrapperId="react-portal-modal-container">
                    <Modal
                        okText={editingDeliverable?.id ? 'Update' : 'Save'}
                        title={editingDeliverable?.is_adding ? 'Add Deliverable or Activity' : (editingDeliverable?.id ? `Edit Deliverable or Activity` : `Create Deliverable or Activity`)}
                        className="project-scope-modal"
                        open={editModalOpen}
                        closable={false}
                        maskClosable={false}
                        destroyOnClose={true}
                        width={800}
                        footer={null}

                    >
                        {editingDeliverable && (
                            <PositionDeliverablesForm
                                submitBtn={(editingDeliverable?.is_adding || !editingDeliverable?.id) ? 'Add' : `Update`}
                                model={editingDeliverable}
                                onCancel={async () => {
                                    if (props.isDisabled || isProjectUpdating) {
                                        return
                                    }

                                    if (editingDeliverable?.is_adding || (!editingDeliverable?.id && !editingDeliverable.name)) {
                                        await toggleDeliverableForm(false);
                                        await TB.wait(300);
                                        return setEditingDeliverable(false);
                                    }
                                    await toggleDeliverableForm(false);
                                    await TB.wait(300);
                                    return  setEditingDeliverable(false);
                                }}
                                onSubmit={async (params) => {

                                    let model = {...params, is_adding: undefined}
                                    let updatedDeliverables = [...positionDeliverables];

                                    if (params.is_adding) {
                                        updatedDeliverables.push(model)
                                    }else {
                                        updatedDeliverables = TB.map(updatedDeliverables, del => {
                                            if (model.id && del.id === model.id) {
                                                return model;
                                            }else if (model.deliverable_id && model.deliverable_id === del.deliverable_id) {
                                                return model;
                                            }
                                            return del;
                                        })
                                    }

                                    await toggleDeliverableForm(false)
                                    await TB.wait(300)
                                    await setSelectedTab('selected-deliverables');
                                    await onChange({deliverables: updatedDeliverables});
                                    await setEditingDeliverable(false)
                                }}/>
                        )}
                    </Modal>
                </ReactPortal>
            )}
        </div>
    );
};

PositionFixedFeeForm.propTypes = {};

export default PositionFixedFeeForm;